export default __webpack_public_path__ + "static/media/28-ART-(3-2).6d8157cf.jpg";